import { Button as MuiButton } from "@mui/material";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";
import { typographyTokens } from "../../../theme/index.js";

FillButton.propTypes = {
  item: PropTypes.object.isRequired,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default function FillButton(props) {
  const { item, onChange, variant = "contained", disabled = false } = props;

  let buttonVariant = variant;
  if (buttonVariant === "filled") buttonVariant = "contained";

  const actions = item.actions || [item.action] || [];

  const processAction = () => {
    actions.forEach((action) => {
      onChange(convertToDefEventPara(action.target, action.value));
    });
  };

  return (
    <MuiButton
      fullWidth
      variant={buttonVariant}
      disabled={disabled}
      onClick={(e) => processAction()}
      sx={{
        fontSize: typographyTokens.size.sm,
        fontWeight: typographyTokens.weight.regular,
        textTransform: "none",
      }}
    >
      {item.label}
    </MuiButton>
  );
}
